import { ReactElement } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useAppSelector } from "../../services/hooks";
import { isAuthSelector } from "../../services/selectors/auth.selectors";

interface IProtectedRoot {
  children: ReactElement;
  redirectPath?: string;
}
function ProtectedRoute({
  children,
  redirectPath = "/login",
}: IProtectedRoot): ReactElement {
  const location = useLocation();
  const isAuth = useAppSelector(isAuthSelector);

  return isAuth ? (
    children
  ) : (
    <Navigate to={redirectPath} state={{ from: location.pathname }} replace />
  );
}

export default ProtectedRoute;
